import _get from 'lodash/get'
import handleActions from 'redux-actions/lib/handleActions'
import { createAsyncHandlers } from '../actions'

const initialState = {
  invitations: {
    attributes: [],
  },
  members: {},
  promoterGenericInvitation: null,
}

const ADD_TOUR_TEAM_INVITATION_LOCAL = createAsyncHandlers('ADD_TOUR_TEAM_INVITATION_LOCAL', {
  success(state, action) {
    const { attributes } = action.payload
    const newInvitations = attributes.emails.map(email => ({
      id: null,
      status: 'pending',
      role: attributes.role,
      eventId: 0,
      tourId: attributes.tourId,
      manufacturerId: 0,
      token: null,
      scope: 'tour',
      type: 'individual',
      email,
      firstName: null,
      lastName: null,
      invitedByCustomerId: null,
    }))
    state.invitations = {
      ...state.invitations,
      attributes: [...newInvitations, ...state.invitations.attributes],
    }
  },
})

const REGENERATE_PROMOTER_GENERIC_INVITATION_TOUR = createAsyncHandlers(
  'REGENERATE_PROMOTER_GENERIC_INVITATION_TOUR',
  {
    success(state, action) {
      state.promoterGenericInvitation = { ...state.promoterGenericInvitation, token: action.payload }
    },
  },
)

const FETCH_TOUR_TEAM_INVITATIONS = createAsyncHandlers('FETCH_TOUR_TEAM_INVITATIONS', {
  success(state, action) {
    const { data } = action.payload
    return (state.invitations = _get(data, '$original'))
  },
})

const FETCH_TOUR_TEAM_MEMBERS = createAsyncHandlers('FETCH_TOUR_TEAM_MEMBERS', {
  success(state, action) {
    const { data } = action.payload
    return (state.members = data.map(d => _get(d, '$original')))
  },
})

const FETCH_TOUR_PROMOTER_GENERIC_INVITATION = createAsyncHandlers('FETCH_TOUR_PROMOTER_GENERIC_INVITATION', {
  success(state, action) {
    state.promoterGenericInvitation = action.payload
  },
})

const UPDATE_TOUR_PROMOTER_GENERIC_INVITATION = createAsyncHandlers(
  'UPDATE_TOUR_PROMOTER_GENERIC_INVITATION',
  {
    success(state, action) {
      const { data } = action.payload
      state.promoterGenericInvitation = {
        ...state.promoterGenericInvitation,
        status: data.$original.attributes.status,
      }
    },
  },
)

export default handleActions(
  {
    ...FETCH_TOUR_TEAM_INVITATIONS,
    ...FETCH_TOUR_TEAM_MEMBERS,
    ...FETCH_TOUR_PROMOTER_GENERIC_INVITATION,
    ...REGENERATE_PROMOTER_GENERIC_INVITATION_TOUR,
    ...UPDATE_TOUR_PROMOTER_GENERIC_INVITATION,
    ...ADD_TOUR_TEAM_INVITATION_LOCAL,
  },
  initialState,
)
